(() => {
  const CONTROLLER_FLAG = 'data-hormonize-about-js-ready';
  const SECTION_SELECTOR = '.hormonize-about';
  const GALLERY_SELECTOR = '[data-hormonize-about-gallery]';

  const instances = new WeakMap();

  class HormonizeAboutController {
    constructor(section) {
      this.section = section;
      this.gallery = section.querySelector(GALLERY_SELECTOR);
      this.carouselController = null;

      if (this.gallery && window.HormonizeScrollCarouselController) {
        this.carouselController = new window.HormonizeScrollCarouselController(this.gallery, {
          viewportSelector: '.hormonize-about__gallery-viewport',
          itemSelector: '.hormonize-about__gallery-slide',
          paginationSelector: '[data-gallery-pagination]',
          prevSelector: '[data-gallery-prev]',
          nextSelector: '[data-gallery-next]',
          statusSelector: '.hormonize-about__gallery-status',
          dotClassName: 'hormonize-about__gallery-dot',
          singleClassName: 'is-single',
          alwaysActive: true,
          snapAlign: 'center',
          slideNoun: 'image',
          slideLabel: 'Gallery image',
          getSlideTitle: (item) => item.getAttribute('data-gallery-title')?.trim() || '',
        });
        this.carouselController.init();
      }
    }

    destroy() {
      this.carouselController?.destroy();
      this.carouselController = null;
      this.section = null;
      this.gallery = null;
    }
  }

  function initAbout(section) {
    if (!(section instanceof HTMLElement) || !section.matches(SECTION_SELECTOR) || instances.has(section)) {
      return;
    }

    instances.set(section, new HormonizeAboutController(section));
  }

  function initAboutSections(root = document) {
    const searchRoot = root instanceof Element || root instanceof Document ? root : document;

    if (searchRoot instanceof Element && searchRoot.matches(SECTION_SELECTOR)) {
      initAbout(searchRoot);
    }

    searchRoot.querySelectorAll(SECTION_SELECTOR).forEach(initAbout);
  }

  function destroyAboutSections(root) {
    const searchRoot = root instanceof Element ? root : document;
    const sections = [];

    if (searchRoot instanceof Element && searchRoot.matches(SECTION_SELECTOR)) {
      sections.push(searchRoot);
    }

    searchRoot.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      const instance = instances.get(section);

      if (!instance) {
        return;
      }

      instance.destroy();
      instances.delete(section);
    });
  }

  function onSectionLoad(event) {
    initAboutSections(event.target);
  }

  function onSectionUnload(event) {
    destroyAboutSections(event.target);
  }

  function bindLifecycleEvents() {
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:section:reorder', () => {
      destroyAboutSections(document);
      initAboutSections(document);
    });
  }

  if (!document.documentElement.hasAttribute(CONTROLLER_FLAG)) {
    document.documentElement.setAttribute(CONTROLLER_FLAG, '');
    bindLifecycleEvents();
  }

  initAboutSections(document);
})();
